import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import cdac from "/app/images/services/service.webp";
import brand from "dan-api/dummy/brand";
import { NavLink } from "react-router-dom";
import link from "dan-api/ui/link";
import useStyles from "./landingStyle-jss";
import FormControl from "@mui/material/FormControl";
import { Input } from "@mui/material";
import Services from "../../Services/Services";
import axios from "axios";
import Swal from "sweetalert2";
import "./Landing.css";
import footerMapBg from "/app/images/footerBg.webp";

let counter = 0;
function createData(name, url) {
  counter += 1;
  return {
    id: counter,
    name,
    url,
  };
}

const footerBackground = {
  backgroundImage: `url(${footerMapBg})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};

function Decoration() {
  const { classes } = useStyles();
  return (
    <div>
      <svg fill="#fff" className={classes.footerDecoration}>
        <use xlinkHref="/images/decoration/petal5.svg#Petal-Bottom" />
      </svg>
    </div>
  );
}

const DecorationStyled = Decoration;

function MainFooter() {
  const formRef = useRef(null);
  const { classes } = useStyles();
  const [email, setEmail] = useState();
  const [isValidEmail, setIsValidEmail] = useState("");
  const menuList = [
    createData("feature", "#feature"),
    createData("showcase", "#showcase"),
    createData("terstimonials", "#testi"),
    createData("technology", "#tech"),
    createData("pricing", "#pricing"),
    createData("contact", "#contact"),
  ];

  const handleInputClick = (event) => {
    validateEmail();
    event.stopPropagation();
  };
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmail(emailRegex.test(email));
    setIsValidEmail(emailRegex.test(email));
  };
  const handleEmailvalidate = () => {
    // validateEmail();
  };

  const subscribeHandler = async (e) => {
    e.preventDefault();

    const data = { email: email };
    Services.subscribe(data)
      .then(async (response) => {
        // console.log("sub res", response);
        if (response.data.status === 1) {
          Swal.fire({
            title: "Success!",
            text: `${response.data.message}`,
            icon: "success",
          });
        } else {
          // console.log("sub responseeeeee", response);
          const errorEmail = response.data.errorMsg;
          setIsValidEmail(errorEmail);
          // Swal.fire({
          //   title: "Error!",
          //   text: `${response.data.errorMsg}`,
          //   icon: "error",
          // });
        }
      })
      .catch((error) => {
        // console.log("subscribe error", error.response.data);
        Swal.fire({
          title: "Warning!",
          text: `${error.response.data.message}`,
          icon: "info",
        });
      });
    formRef.current.reset();
  };

  // console.log("emailllllll", isValidEmail);
  return (
    <div className="mt-4">
      <div className="custom-shape-divider-top-1686811251 d-none">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            className="shape-fill"
          ></path>
        </svg>
      </div>
      <footer className={classes.footer}>
        <DecorationStyled />
        {/* <div className={classes.container}>
          <div className={classes.spaceContainer}>
            <div className={classes.brand}>
              <img src={cdac} alt={brand.name} />
              {brand.name}
            </div>
            <nav>
              <ul>
                {menuList.map((item) => (
                  <li key={item.id.toString()}>
                    <Button size="small" href={item.url}>
                      {item.name}
                    </Button>
                  </li>
                ))}
              </ul>
            </nav>
           
          </div>
        </div> */}
        <div
          className={` footerMain  ${classes.container}`}
          style={footerBackground}
        >
          <div className="container">
            <div className="row text-left">
              <div className="col-md-3">
                <div className={classes.sideContentFooter}>
                  <div>
                    <div
                      className={`float-left footerSidemainHeading ${classes.brand}`}
                      style={{ float: "left" }}
                    >
                      <img src={cdac} alt={brand.name} />
                      {brand.name}
                    </div>
                  </div>
                  <div className="pt-2">
                    <p>
                      ISEA resources as a single point of contact for all
                      stakeholders of ISEA community.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div>
                  <h4>Useful Links</h4>
                </div>
                <div>
                  <ul>
                    <li>
                      <NavLink to="/">Home</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">About</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">Services</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div>
                  <h4>Other Services</h4>
                </div>
                <div>
                  <ul>
                    <li>
                      <NavLink to="/">Virtual Labs</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">Learning Management System</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">Assessment & Training </NavLink>
                    </li>
                    <li>
                      <NavLink to="/">ISEA Forms</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">Digital Forum</NavLink>
                    </li>
                    <li>
                      <NavLink to="/">Content Aggregation Platform</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="subscribeUS">
                  <h4>Subscribe </h4>
                  <p>Subscribe to our email, updates and more.</p>
                  <form ref={formRef} onClick={(e) => subscribeHandler(e)}>
                    <div className="d-flex  formControl-subscribe">
                      <FormControl className="Form-conrol-subscribe">
                        <Input
                          id="exampleFormControlInput1"
                          placeholder="name@cdac.in"
                          type="email"
                          required
                          onChange={handleChange}
                          onClick={handleInputClick}
                          onBlur={handleEmailvalidate}
                        />
                      </FormControl>
                      <span>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                        >
                          <i
                            className="fa fa-paper-plane"
                            aria-hidden="true"
                          ></i>
                        </Button>
                      </span>
                    </div>
                  </form>
                  <span>
                    {isValidEmail ? (
                      <p className="text-danger">{isValidEmail}</p>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={` mb-0   ${classes.copyright}`}>
          <div className={classes.container}>
            <div className={classes.lowerFooter}>
              <p>&copy; {new Date().getFullYear()} CDAC. All Right Reserved </p>
              <span>
                <IconButton
                  color="primary"
                  className={classes.button}
                  href={link.twitter}
                  target="_blank"
                  size="large"
                >
                  <i className="ion-logo-twitter" />
                </IconButton>
                <IconButton
                  color="primary"
                  className={classes.button}
                  href={link.pinterest}
                  target="_blank"
                  size="large"
                >
                  <i className="ion-logo-pinterest" />
                </IconButton>
                <IconButton
                  color="primary"
                  className={classes.button}
                  href={link.github}
                  target="_blank"
                  size="large"
                >
                  <i className="ion-logo-github" />
                </IconButton>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default MainFooter;
